export default __webpack_public_path__ + "static/slide-frame-paper2-724956d186ef36cefc2d1bad9593a06e.png";